<template>
    <div>
        <b-table
            :empty-text="$t('there_are_no_records')"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            show-empty
            class="mb-5 table-dropdown no-scrollbar border rounded"
        >
            <template v-slot:cell(reason_text)="row">
                {{ getLocaleText(row.item, 'reason_text') }}
            </template>
            <template v-slot:cell(active_approver)="{item}">
                <div v-if="item.active_step?.name">
                    {{ getLocaleText(item.active_step, 'name') }}
                </div>
                <div v-else-if="item.active_step">
                    <span v-for="(approver, index) in item.active_step.approvers" :key="index">
                        {{ getLocaleText(approver, 'explanation') }}
                        <span v-if="index < item.active_step.approvers.length - 1">, </span>
                    </span>
                </div>
            </template>
        </b-table>
    </div>
</template>

<script>
import LeaveWithConsentService from "@/services/LeaveWithConsentService";

/**
 * Leave With Consent Tab Component
 */
export default {
    name: 'LeaveWithConsentTab',
    data() {
        return {
            items: [],
            fields: [
                {
                    key: this.getLocaleField('program_name'),
                    label: this.toUpperCase('program'),
                },
                { key: 'academic_year', label: this.toUpperCase('academic_year') },
                { key: 'reason_text', label: this.toUpperCase('reason') },
                { key: 'explanation', label: this.toUpperCase('explanation') },
                { key: 'created_at', label: this.toUpperCase('date') },
                { key: 'active_approver', label: this.toUpperCase('at_which_unit') },
                { key: this.getLocaleField('status_text'), label: this.toUpperCase('status') },
            ],
        };
    },
    methods: {
        fetchData() {
            LeaveWithConsentService.studentRequests()
                .then(response => {
                    this.items = response.data.data;
                    this.items.forEach(item => {
                        if (item.active_step && item.active_step.approvers) {
                            let arr = [];
                            item.active_step.approvers.forEach(approver => {
                                arr.push(this.getLocaleText(approver, 'explanation'));
                            });
                            item.active_approver = arr.join(', ');
                        }
                    });
                })
                .catch(e => {
                    this.showErrors(e);
                });
        }
    },
    created() {
        this.fetchData();
    }
};
</script>
